<template>
  <div class="store-cart-wrap">
    <div class="content-wrap">
      <div class="my-breadcrumb">
        <span>我的位置：</span>
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><a href="#">首页</a></li>
            <li class="breadcrumb-item active" aria-current="page">我的购物车单</li>
          </ol>
        </nav>
      </div>
      <div class="cart-card">
        <div class="my-step">
          <div class="step-icon step-icon-sel">1</div>
          <p class="step-name step-name-sel">我的购物车</p>
          <img src="~@/assets/images/step_next_icon.png" class="step-arrow" alt="">
          <div class="step-icon step-icon-sel">2</div>
          <p class="step-name step-name-sel">核对下单</p>
          <img src="~@/assets/images/step_next_icon.png" class="step-arrow" alt="">
          <div class="step-icon">3</div>
          <p class="step-name">支付订单</p>
        </div>
        <div class="step1">
          <div class="table-wrap">
            <table class="table align-middle">
              <thead class="table-light">
                <tr>
                  <th scope="col">
                    <input style="margin-top: 0;" class="form-check-input" type="checkbox" value=""
                      id="flexCheckDefault">
                  </th>
                  <th scope="col">货号</th>
                  <th scope="col">商品名称</th>
                  <th scope="col">品牌</th>
                  <th scope="col">平台原价</th>
                  <th scope="col">单价</th>
                  <th scope="col">数量（件）</th>
                  <th scope="col">金额（元）</th>
                  <th scope="col">操作</th>
                </tr>
              </thead>
              <tbody>
                <!-- <tr>
													<th scope="row" class="align-middle">
														<input style="margin-top: 0;" class="form-check-input" type="checkbox" value="" id="flexCheckDefault">
													</th>
													<td class="align-middle">32132132131</td>
													<td class="align-middle">测试商品6666</td>
													<td class="align-middle">元素魔方</td>
													<td class="align-middle">10.00</td>
													<td class="align-middle">10.00</td>
													<td class="align-middle">6</td>
													<td class="align-middle">60.00</td>
													<td class="align-middle"></td>
												</tr> -->
              </tbody>
            </table>
            <div class="empty">
              <img src="~@/assets/images/cart_empty.png" alt="">
            </div>
          </div>
          <div class="total-wrap">
            <p>
              <span>已选商品<i>2</i>件</span>
              <span>合计：</span>
              <i>￥</i><span class="price">0.00</span>
            <div class="my-btn">结算</div>
            </p>
          </div>
          <div class="order-tip-card">
            <div class="title">下单须知</div>
            <div class="tip">
              ① 当前系统不支持支付后修改价格，如您对价格或折扣有异议，请在订单支付前联系我们的技术顾问，李老师：183 3921 8928 。<br>
              ② 商城中未标明价格的产品为报价产品，该类产品将在下单后会由专属客户经理为您提供报价，如有任何问题欢迎咨询指南针商城客服人员。<br>
              ③
              您在指南针商城购买的试剂耗材类产品如有质量问题，均可在收货后七天内联系商城客服人员，我们将为妥善为您处理；如您收货后七天内未反馈有质量问题，则默认该产品无质量问题；凡在商城购买的试剂耗材类产品，因非质量问题引起的退换货，客户需承担销售订单金额20%的手续费。<br>
              ④ 商城单笔订单满99元包邮，未满99元需额外加收运费。<br>
              ⑤
              因厂家会在没有任何提前通知的情况下更改产品价格、包装、产地或者一些附件，且有时会变更货期，若出现价格或货期异常请以厂家官网信息为准，本司不能确保客户收到的货物与商城图片、产地、附件说明完全一致，只能确保为原厂正货！且保证与当时市场上同样主流新品一致。若本商城没有及时更新，请大家谅解！如遇商品价格、货期不准的问题，我们的专属客户经理会主动联系您。<br>
              ⑥ 对于含有危化品的订单，我们会以“上海研溯科技有限公司”为主体，对危化品单独开票。
            </div>
          </div>
        </div>
        <div class="step2 active-step">
          <div class="my-form">
            <form>
              <div class="form-item">
                <label>选择地址</label>
                <select class="form-control">
                  <option value="option1">选项1</option>
                  <option value="option2">选项2</option>
                  <option value="option3">选项3</option>
                </select>
              </div>
              <div class="form-item">
                <label>收件人</label>
                <input type="text" class="form-control" id="num" value="" placeholder="请输入收件人">
              </div>
              <div class="form-item">
                <label>联系电话</label>
                <input type="text" class="form-control" id="num" value="" placeholder="请输入收件人">
              </div>
              <div class="form-item">
                <label>收货地址</label>
                <div style="display:flex;align-items: center;column-gap: 10px;">
                  <select class="form-control">
                    <option value="option1">选项1</option>
                    <option value="option2">选项2</option>
                    <option value="option3">选项3</option>
                  </select>
                  <select class="form-control">
                    <option value="option1">选项1</option>
                    <option value="option2">选项2</option>
                    <option value="option3">选项3</option>
                  </select>
                  <select class="form-control">
                    <option value="option1">选项1</option>
                    <option value="option2">选项2</option>
                    <option value="option3">选项3</option>
                  </select>
                </div>
              </div>
              <div class="form-item">
                <label>详细地址</label>
                <textarea class="form-control" rows="6"></textarea>
              </div>
            </form>
            <button class="my-btn">保存新增地址</button>
            <div style="clear: both;"></div>
          </div>
          <div class="order-table">
            <div class="title">确认订单信息</div>
            <div class="table-wrap">
              <table class="table align-middle">
                <thead class="table-light">
                  <tr>
                    <th scope="col">货号</th>
                    <th scope="col">商品名称</th>
                    <th scope="col">品牌</th>
                    <th scope="col">平台原价</th>
                    <th scope="col">单价</th>
                    <th scope="col">数量（件）</th>
                    <th scope="col">金额（元）</th>
                    <th scope="col">操作</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="align-middle">32132132131</td>
                    <td class="align-middle">测试商品6666</td>
                    <td class="align-middle">元素魔方</td>
                    <td class="align-middle">10.00</td>
                    <td class="align-middle">10.00</td>
                    <td class="align-middle">6</td>
                    <td class="align-middle">60.00</td>
                    <td class="align-middle"></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="action-btn">
            <button class="my-btn per-btn">返回上一步</button>
            <button class="my-btn submit-btn">提交订单</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getIndex } from "@/api/index";

export default {
  name: "CartIndex",
  components: {},
  data() {
    return {
      loading: true,
    };
  },
  computed: {},
  created() {
    this.getIndex();
  },
  methods: {
    getIndex() {
      getIndex({})
        .then((res) => {
          this.loading = false;
          this.user = res.data;
        })
        .catch((err) => { });
    },
  },
};
</script>

<style lang="scss" scoped>
.store-cart-wrap {
  width: 100%;
  padding-top: 34px;
  padding-bottom: 75px;
  box-sizing: border-box;
  background-color: #f4f8f9;
  display: flex;
  align-items: center;
  flex-direction: column;

  .content-wrap {
    width: 1200px;
    display: flex;
    align-items: center;
    flex-direction: column;

    .my-breadcrumb {
      width: 100%;
    }

    .cart-card {
      width: 100%;
      margin-top: 15px;
      background: #ffffff;
      box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.0196);
      padding: 30px 15px 71px 15px;
      box-sizing: border-box;

      .my-step {
        width: 100%;
        justify-content: center;
      }

      .active-step {
        display: block !important;
      }

      .step1 {
        display: none;
        width: 100%;

        .table-wrap {
          width: 100%;
          margin-top: 35px;

          .empty {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .table {
            th:nth-child(1) {
              width: 48px;
            }

            th:nth-child(2) {
              width: 244px;
            }

            th:nth-child(3) {
              width: 157px;
            }

            th:nth-child(4),
            th:nth-child(5),
            th:nth-child(6),
            th:nth-child(7),
            th:nth-child(7) {
              width: 110px;
            }

            th:nth-child(9) {
              width: 152px;
            }
          }
        }

        .total-wrap {
          width: 100%;
          font-size: 20px;
          font-weight: 400;
          color: #222222;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          margin-top: 41px;

          i {
            color: #ff6666;
          }

          .price {
            font-size: 32px;
            font-weight: bold;
            color: #ff6666;
          }

          .my-btn {
            padding: 11px 67px;
            font-size: 13px;
            font-weight: 300;
            color: #ffffff;
            margin-left: 42px;
          }
        }

        .order-tip-card {
          width: 100%;
          padding: 30px 15px 0 15px;
          box-sizing: border-box;
          border-top: 1px solid #ccd7db;
          background: #ffffff;
          margin-top: 100px;

          .title {
            font-size: 20px;
            font-weight: bold;
            color: #6f7f84;
          }

          .tip {
            font-size: 16px;
            font-weight: 400;
            color: #6f7f84;
            line-height: 30px;
            margin-top: 16px;
          }
        }
      }

      .step2 {
        width: 100%;
        margin-top: 35px;

        .my-form {
          width: 50%;
          margin: 0 auto;
          padding-bottom: 20px;

          .my-btn {
            padding: 11px 67px;
            font-size: 13px;
            font-weight: 300;
            color: #ffffff;
            margin-left: 42px;
            background-color: #ffffff;
            color: #00b4e8;
            border: 1px solid #00b4e8;
            margin-top: 20px;
            float: right;
          }
        }

        .order-table {
          width: 100%;
          border-top: 1px solid #ccd7db;
          padding-top: 58px;

          .table {
            th:nth-child(1) {
              width: 244px;
            }

            th:nth-child(2) {
              width: 157px;
            }

            th:nth-child(3),
            th:nth-child(4),
            th:nth-child(5),
            th:nth-child(6),
            th:nth-child(7) {
              width: 110px;
            }

            th:nth-child(8) {
              width: 152px;
            }
          }

          .title {
            font-size: 20px;
            font-weight: 400;
            color: #6f7f84;
            margin-bottom: 15px;
          }
        }

        .action-btn {
          margin-top: 20px;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          column-gap: 20px;

          .per-btn {
            font-size: 13px;
            font-weight: 300;
            color: #00b4e8;
            padding: 10px 48px;
            border-radius: 20px;
            border: 1px solid #00b4e8;
            background-color: #ffffff;
          }

          .submit-btn {
            font-size: 13px;
            font-weight: 300;
            color: #ffffff;
            padding: 10px 54px;
            background: #00b4e8;
            border-radius: 20px;
          }
        }
      }
    }
  }
}
</style>
